import React from "react";
import { InputFactory as Factory } from "nq-component";
import { findObjectUseCase, saveObjectUseCase } from "../../usecases/object";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import Context from "../../AppContext";
import Parse from "./Parse";
import Time from "./Time";
import TIN from "./TIN";
import Phil from "./Phil";
import TextArea from "./TextArea";
import InputRelation from "../InputRelation";
import DecemalNum from "./DecemalNum";
import InputFileMultiple from "../InputFile";
import InputSelect from "../InputSelect";
import RelatedFactory from "../RelatedFactory";
import StringArray from "./StringArray";
import InputString from "../InputString";
import UserPointer from "../UserPointer";
import InputPointer from "../InputPointer";
import AntRelation from "../AntRelation";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import DateRange from "./DateRange";
import { passwordInputProps } from "./passwordPolicy";

const defaultProps = {};

function InputFactory({
  type,
  _type,
  percent,
  field,
  object,
  values,
  onChange,
  ...props
}) {
  const context = React.useContext(Context);
  const value =
    props.value !== undefined ? props.value : object && object[field];

  function _onChange(field, value) {
    if (object) {
      object[field] = value;
    }
    onChange(value, field);
  }

  switch (_type || type) {
    case "Related":
      return (
        <RelatedFactory
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            (context.schemas || []).find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );
    case "parseNumber":
      return (
        <Parse
          defaultValue={value}
          _type={_type}
          percent={percent}
          // value={value}

          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );
    case "File":
    case "InputFile":
      return (
        <InputFileMultiple
          value={value}
          onChange={_onChange.bind(this, field)}
          saveFile={saveFileUseCase()}
          {...props}
        />
      );

    case "DateRange":
      return (
        <DateRange
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={props.required || props._required}
          schema={
            props.schema ||
            context.schemas?.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );
    // case "emPointer":
    //   const schema =
    //     props.schema ||
    //     context.schemas.find((s) => s.collection === props.target);
    //   if (!schema) return null;
    //   return (
    //     <InputPointer
    //       field={field}
    //       defaultValue={value}
    //       onChange={_onChange.bind(this, field)}
    //       findObject={findObjectUseCase()}
    //       schema={
    //         props.schema ||
    //         context.schemas.find((s) => s.collection === props.target)
    //       }
    //       pick={"users"}
    //       schemas={context.schemas}
    //       {...props}
    //     />
    //   );
    case "InputSelect":
      return (
        <InputSelect
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          placeholder={
            props.placeholder ||
            (props.dynamic ? "Select of type " : "Select ") +
              (props.label || field)
          }
          // required={props._required || props.required}
          {...props}
        />
      );
    case "Relation":
      return (
        <InputRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={props._required || props.required}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          {...props}
        />
      );

    case "AntRelation":
      return (
        <AntRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          findObject={findObjectUseCase()}
          object={object}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          {...props}
        />
      );

    // case "RelationString":
    //   return (
    //     <InputRelation
    //       field={field}
    //       defaultValue={value}
    //       onChange={_onChange.bind(this, field)}
    //       schemas={context.schemas}
    //       // required={_required || required}
    //       {...props}
    //     />
    //   );

    case "Pointer":
      return (
        <UserPointer
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          findObject={findObjectUseCase()}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          required={props._required || props.required}
          {...props}
        />
      );

    case "inputPointer":
      return (
        <UserPointer
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          // where={{ id: "d1b8a400-f9ce-4cf3-a5a9-84ad08e05084" }}
          findObject={findObjectUseCase()}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          // required={_required || required}
          {...props}
        />
      );

    case "_time":
      return (
        <Time
          _type={_type}
          percent={percent}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );

    case "RichText":
      return (
        <RichTextEditor
          value={value}
          onChange={_onChange.bind(this, field)}
          required={props.required || props._required}
          {...props}
        />
      );

    case "StringArray":
      return (
        <StringArray
          _type={_type}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );

    case "tin":
      return (
        <TIN
          _type={_type}
          percent={percent}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );

    case "phil":
      return (
        <Phil
          _type={_type}
          percent={percent}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );
    case "DecemalNum":
      return (
        <DecemalNum
          _type={_type}
          percent={percent}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );

    case "textArea":
      return (
        <TextArea
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );

    case "String":
    case "string":
      return (
        <InputString
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          {...props}
        />
      );

    case "password":
    case "Password": {
      const {
        pattern,
        minLength,
        title,
        placeholder,
        placeHolder,
        hashed: _hashed,
        salted: _salted,
        access: _access,
        read: _read,
        _type: _ignoredType,
        ...rest
      } = props;
      const policy =
        pattern || minLength
          ? passwordInputProps({ pattern, minLength, title, placeholder, placeHolder })
          : { placeholder: placeholder || placeHolder };
      return (
        <Factory
          type="Password"
          field={field}
          object={object}
          schemas={context.schemas}
          onChange={onChange}
          required={rest._required || rest.required}
          findObject={findObjectUseCase()}
          saveObject={saveObjectUseCase()}
          saveImage={saveImageUseCase()}
          saveFile={saveFileUseCase()}
          {...rest}
          {...policy}
        />
      );
    }

    default:
      return (
        <Factory
          type={type}
          _type={_type}
          field={field}
          object={object}
          schemas={context.schemas}
          onChange={onChange}
          required={props._required || props.required}
          findObject={findObjectUseCase()}
          saveObject={saveObjectUseCase()}
          saveImage={saveImageUseCase()}
          saveFile={saveFileUseCase()}
          {...props}
        />
      );
  }
}

InputFactory.defaultProps = defaultProps;
export default InputFactory;
